import { createStyles } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { CustomPalette, MaterialPalette } from '@nutrien/cxp-components';

const useStyles = makeStyles(() =>
  createStyles({
    dialogContent: {
      padding: '16px',
      width: '400px',
      backgroundColor: CustomPalette.elevation.dp4Solid,
      overflowY: 'scroll',
    },
    rightAlign: {
      display: 'flex',
      justifyContent: 'flex-end',
      width: '91px',
      height: '44px',
      float: 'right',
    },
    textFieldSection: {
      height: '47px',
    },

    gridAlign: {
      alignSelf: 'normal',
      '& .textFieldText': {
        color: MaterialPalette.text.primary,
        marginBottom: '10px',
      },
    },
  }),
);

export default useStyles;
